module.exports = __webpack_public_path__ + "static/media/time.00e68711.svg";